import Vue from 'vue';
import VueRouter from 'vue-router';

// Layouts
import FrontendLayout from '@/views/Layouts/Frontend';
import AdminLayout from '@/views/Layouts/Admin';

// Children
import { FrontendChildren } from './frontend';
import { AdminChildren } from './admin';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: FrontendLayout,
    ...FrontendChildren,
  },
  {
    path: '/admin',
    component: AdminLayout,
    ...AdminChildren,
  },
  {
    path: '*',
    component: FrontendLayout,
    children: [
      {
        name: '404 Error',
        path: '',
        component: () => import('@/views/Error'),
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});

router.beforeEach(async (to, from, next) => {
  console.log('to', to, 'from', from);
  console.log('to.meta', to.meta);
  const { authorize } = to.meta;

  if (authorize) {
    console.log('Authenticated Route', authorize);
  } else {
    console.log('Public Route');
  }
  const loggedIn = localStorage.getItem('token');
  const role = localStorage.getItem('role');

  if (to.fullPath.substr(0, 2) === '/#') {
    const path = to.fullPath.substr(2);
    next(path);
    return;
  }

  if (authorize && !loggedIn) return next({ name: 'Login' });

  if (authorize && !role) return next({ name: 'Login' });

  if (role && authorize && !authorize.includes(role)) return next({ name: 'Home' });
  if (to && to.meta && typeof document !== 'undefined') {
    const defaultTitle = 'Service Finder';
    const title = to.meta.title || defaultTitle;
    const description =
      to.meta.description || 'Find health and support facilities near you. Browse categories and get directions.';
    const image = to.meta.ogImage || '/img/location.png';
    document.title = title;

    function setMeta(name, content, attr = 'name') {
      let el = document.querySelector(`meta[${attr}='${name}']`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    }

    setMeta('description', description);
    setMeta('og:title', title, 'property');
    setMeta('og:description', description, 'property');
    setMeta('og:type', 'website', 'property');
    setMeta('og:image', image, 'property');
    setMeta('og:url', typeof window !== 'undefined' ? window.location.href : '', 'property');
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', title);
    setMeta('twitter:description', description);
    setMeta('twitter:image', image);
  }
  return next();
});

export default router;
